<cms-modal-layout>
  <span title class="title">Online Now</span>

  <div content class="d-flex flex-column align-items-center">
    <span>  {{internalUsers.length > 0 ? projectInfo.name + ' Users:' : 'No ' + projectInfo.name + ' Users'}} </span>
    @if (internalUsers.length > 0 ) {
      @for (user of internalUsers; track user) {
        <span>{{user.fullName}}</span>
      }
    }


  </div>

  <span closeBtnTitle>Cancel</span>


</cms-modal-layout>
